import React, { useState } from 'react'
import { cl } from '../../../../../../utilities/cl'

const Accordion = ({ section, titles, selected, markItems, onSelect }) => {
    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)

    const handleClick = (e) => {
        const helpItem = e.target.closest(".HelpMenuItem")
        if (!helpItem) return
        const helpItemId = Number(helpItem.dataset.helpId)
        if (onSelect) onSelect(helpItemId)
    }

    return (
        <div className="Accordion">
            <div className="AccordionHeader selectable-item" onClick={toggle}>
                <span>{section}</span>
                <span className="AccordionArrow">{open ? '▲' : '▼'}</span>
            </div>

            {open && (
                <div className="AccordionContent" onClick={handleClick}>
                    {titles.map((title) => {
                        const className = cl(
                            "selectable-item",
                            { "selected": selected.includes(title.index) },
                            { "highlighted": markItems.includes(title.index) },
                        )
                        return (
                            <div
                                key={title.index}
                                className={`HelpMenuItem ${className}`}
                                data-help-id={title.index}
                            >
                                <span>{title.title}</span>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default Accordion
